export const resetForm = (formValues: any, initialValues: object) => {
  for (const [key, value] of Object.entries(initialValues)) {
    formValues.set(key, value);
  }
};
